var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.outUrl,"width":"100%","height":"800","frameborder":"0","scrolling":"auto","id":"iframename","name":"iframename"}})
}
var staticRenderFns = []

export { render, staticRenderFns }